import { render, staticRenderFns } from "./CardUserRoles.vue?vue&type=template&id=c1faf17a&"
import script from "./CardUserRoles.vue?vue&type=script&lang=js&"
export * from "./CardUserRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports